module.exports = __webpack_public_path__ + "img/slide05.ac28f3b1.jpg";